var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Layout', [_c('div', {
    staticClass: "grid-toolbar"
  }, [_c('Button', {
    on: {
      "click": function click($event) {
        _vm.showAddModal = true;
      }
    }
  }, [_vm._v("新增")]), _c('Button', {
    attrs: {
      "disabled": _vm.selection.length !== 1
    },
    on: {
      "click": function click($event) {
        _vm.showUpdateModal = true;
      }
    }
  }, [_vm._v("编辑")]), _c('Button', {
    attrs: {
      "disabled": _vm.selection.length !== 1
    },
    on: {
      "click": _vm.removeProducts
    }
  }, [_vm._v("删除")]), _c('Button', {
    attrs: {
      "disabled": _vm.selection.length !== 1
    },
    on: {
      "click": _vm.deactiveProducts
    }
  }, [_vm._v("停用")])], 1), _c('Table', {
    ref: "grid",
    attrs: {
      "border": "",
      "columns": _vm.columns,
      "data": _vm.data,
      "loading": _vm.pageLoading
    },
    on: {
      "on-sort-change": _vm.onSortChange,
      "on-selection-change": _vm.onSelectionChange,
      "on-row-click": _vm.onRowClick
    }
  }), _c('div', {
    staticClass: "grid-toolbar"
  }, [_c('Page', {
    attrs: {
      "current": _vm.currentPage,
      "total": _vm.total,
      "page-size": _vm.pageSize,
      "show-total": ""
    },
    on: {
      "on-change": _vm.onCurrentPageChange
    }
  }), _c('RadioGroup', {
    staticClass: "page-selector",
    attrs: {
      "type": "button"
    },
    model: {
      value: _vm.pageSize,
      callback: function callback($$v) {
        _vm.pageSize = $$v;
      },
      expression: "pageSize"
    }
  }, _vm._l([10, 25, 50, 100], function (num) {
    return _c('Radio', {
      key: num,
      attrs: {
        "label": num
      }
    }, [_vm._v(_vm._s(num))]);
  }), 1)], 1), _c('ProductModal', {
    attrs: {
      "title": "新增产品"
    },
    on: {
      "close": _vm.onModalClose
    },
    model: {
      value: _vm.showAddModal,
      callback: function callback($$v) {
        _vm.showAddModal = $$v;
      },
      expression: "showAddModal"
    }
  }), _c('ProductModal', {
    attrs: {
      "from": "update",
      "product": _vm.selection[0],
      "title": "编辑产品"
    },
    on: {
      "close": _vm.onModalClose
    },
    model: {
      value: _vm.showUpdateModal,
      callback: function callback($$v) {
        _vm.showUpdateModal = $$v;
      },
      expression: "showUpdateModal"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };